module.exports = __webpack_public_path__ + "static/img/3-05.ac7636b.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/3-05.png
// module id = 232
// module chunks = 0